<template>
  <div class="inline-flex items-end gap-3">
    <!-- From and To as one piece, so in a wrapping filter bar they move to the next line together. -->
    <label class="inline-flex flex-col gap-0.5">
      <span :class="FILTER_LABEL">{{ fromLabel }}</span>
      <input :value="from" type="date" :class="[FILTER_BOX, 'w-36']" @input="$emit('update:from', $event.target.value)">
    </label>
    <label class="inline-flex flex-col gap-0.5">
      <span :class="FILTER_LABEL">{{ toLabel }}</span>
      <input :value="to" type="date" :class="[FILTER_BOX, 'w-36']" @input="$emit('update:to', $event.target.value)">
    </label>
  </div>
</template>

<script>
import { FILTER_BOX, FILTER_LABEL } from './filterBox';

export default {
  name: 'FilterDateRange',
  props: {
    from: { type: String, default: '' },
    to: { type: String, default: '' },
    fromLabel: { type: String, default: 'From' },
    toLabel: { type: String, default: 'To' },
  },
  emits: ['update:from', 'update:to'],
  data() {
    return { FILTER_BOX, FILTER_LABEL };
  },
};
</script>
